<template>
  <div class="summary">
    <div class="items">
      <div class="item" v-if="errorMessage">
        <div>{{ errorMessage }}</div>
      </div>
      <div v-for="e in errorDescriptions" :key="e">{{ e[0] }}</div>
    </div>
  </div>
</template>
<script setup>
import {computed, defineProps} from 'vue'

const props = defineProps({
  errorData: {
    type: Object
  },
  isLoading: {
    type: Boolean,
    default: false
  }
})

const errorCode = computed(() => {
  return props.errorData?.response?.status
})

const errorMessage = computed(() => {
  if (errorCode.value === 404) return "Не удалось получить данные. Попробуйте снова";
  if (errorCode.value === 500) return props.errorData?.response?.data?.message || "Неизвестная ошибка сервера";
  return props.errorData?.response?.data?.message || props.errorData?.message || "Неизвестная ошибка"
})

const errorDescriptions = computed(() => {
  return props.errorData?.response?.data?.errors || props.errorData?.errors || []
})


</script>

<style scoped>
.summary {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.items {
  margin: auto;
}

.item {
  text-align: center;
  margin: auto;
}
</style>
